import { render, staticRenderFns } from "./COAList.vue?vue&type=template&id=4453212e&scoped=true&lang=pug"
import script from "./COAList.vue?vue&type=script&lang=js"
export * from "./COAList.vue?vue&type=script&lang=js"
import style0 from "./COAList.vue?vue&type=style&index=0&id=4453212e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453212e",
  null
  
)

export default component.exports